import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1 21V7H5.5L8 3H16L18.5 7H23V21H1Z",
      stroke: "white",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.5 13.0352C8.5 13.4948 8.59053 13.9499 8.76642 14.3745C8.94231 14.7992 9.20012 15.185 9.52513 15.51C9.85013 15.835 10.236 16.0928 10.6606 16.2687C11.0852 16.4446 11.5404 16.5352 12 16.5352C12.4596 16.5352 12.9148 16.4446 13.3394 16.2687C13.764 16.0928 14.1499 15.835 14.4749 15.51C14.7999 15.185 15.0577 14.7992 15.2336 14.3745C15.4095 13.9499 15.5 13.4948 15.5 13.0352C15.5 12.5755 15.4095 12.1204 15.2336 11.6958C15.0577 11.2711 14.7999 10.8853 14.4749 10.5603C14.1499 10.2353 13.764 9.97747 13.3394 9.80158C12.9148 9.62569 12.4596 9.53516 12 9.53516C11.5404 9.53516 11.0852 9.62569 10.6606 9.80158C10.236 9.97747 9.85013 10.2353 9.52513 10.5603C9.20012 10.8853 8.94231 11.2711 8.76642 11.6958C8.59053 12.1204 8.5 12.5755 8.5 13.0352Z",
      stroke: "white",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }